import React, { useState } from 'react';

const PillsInput = ({ value = [], onChange, placeholder = 'Add keyword...' }) => {
  const [input, setInput] = useState('');

  const handleInputChange = (e) => setInput(e.target.value);

  const handleKeyDown = (e) => {
    if ((e.key === ',' || e.key === 'Tab') && input.trim()) {
      e.preventDefault();
      addPill();
    } else if (e.key === 'Backspace' && !input && value.length > 0) {
      onChange(value.slice(0, -1));
    }
  };

  const addPill = () => {
    const trimmed = input.trim();
    if (trimmed && !value.includes(trimmed)) {
      onChange([...value, trimmed]);
    }
    setInput('');
  };

  const removePill = (idx) => {
    onChange(value.filter((_, i) => i !== idx));
  };

  return (
    <div>
      <div className="flex mb-2 w-full">
        <input
          type="text"
          className="border border-gray-300 rounded-l-md px-3 py-2 flex-1 focus:outline-none focus:ring-2 focus:ring-blue-200"
          placeholder={placeholder}
          value={input}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
        <button
          type="button"
          className="bg-gray-100 border border-l-0 border-gray-300 rounded-r-md px-4 py-2 text-gray-700 font-medium hover:bg-gray-200 focus:outline-none"
          onClick={addPill}
          disabled={!input.trim()}
          style={{ minWidth: 60 }}
        >
          Add
        </button>
      </div>
      <div className="flex flex-wrap gap-2">
        {value.map((kw, idx) => (
          <span
            key={kw + idx}
            className="flex items-center bg-gray-100 text-gray-800 px-4 py-1 rounded-full text-base font-normal shadow-sm"
          >
            {kw}
            <button
              type="button"
              className="ml-2 text-gray-400 hover:text-red-500 focus:outline-none text-lg"
              onClick={() => removePill(idx)}
              aria-label="Remove keyword"
              style={{ lineHeight: 1 }}
            >
              ×
            </button>
          </span>
        ))}
      </div>
    </div>
  );
};

export default PillsInput; 